module.exports = __webpack_public_path__ + "img/tower_true.9e638794.png";